module.exports = __webpack_public_path__ + "static/media/iUSD.21d687fe.svg";